import React from 'react';
import { Shield, Users, Wrench } from 'lucide-react';
export function ValuesSection() {
  return <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-166">
      <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-167">
        <Shield className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-168" />
        <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-169">
          Reliability First
        </h3>
        <p className="text-gray-600" data-id="element-170">
          Equipment failure costs money. We design for simplicity and durability
          to keep you working.
        </p>
      </div>
      <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-171">
        <Wrench className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-172" />
        <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-173">
          Contractor Focused
        </h3>
        <p className="text-gray-600" data-id="element-174">
          Every feature is designed around the real-world needs of remediation
          and maintenance pros.
        </p>
      </div>
      <div className="text-center p-8 bg-brand-light rounded-xl border border-gray-100" data-id="element-175">
        <Users className="h-12 w-12 text-brand-yellow mx-auto mb-4" data-id="element-176" />
        <h3 className="text-xl font-bold text-brand-dark mb-3" data-id="element-177">Efficiency</h3>
        <p className="text-gray-600" data-id="element-178">
          Time is money. Our systems set up fast, spray fast, and clean up fast.
        </p>
      </div>
    </div>;
}